/*
  The variants probability attribute is an INT that represents the probability
  of a given variant to appear.

  How to properly write variants probability:

  Ex. for a 25% 25% 25% 25% distribution

  We need to start by writing those probabilities as fractional numbers
  25/100 25/100 25/100 25/100

  Then we simplify the fraction in a way that all denominators are the same for
  our example that would be
  1/4 1/4 1/4 1/4

  Then the value of the variants probability will be all numerators
  variantsProbability: [1, 1, 1]


  Ex. 2 for a 50% 30% 20% distribution

  We need to start by writing those probabilities as fractional numbers
  50/100 30/100 20/100

  Then we simplify the fraction in a way that all denominators are the same for
  our example that would be
  5/10 3/10 2/10

  Then the value of the variants probability will be all numerators
  variantsProbability: [5, 3, 2]

  NOTE: for a distribution that have the same percentage on each variant is
  enough to write as many 1's as variants are in the experiment

  Example:
  'WEB-4690': {
    active: true,
    affiliates: [],
    id: 'WEB-4690',
    markets: [],
    devices: [],
    variants: [0, 1],
    variantsProbability: [1, 1],
  },

 */

import {
  AFFILIATE_KAYAK,
  AFFILIATE_SKYSCANNER,
  AFFILIATE_TRIVAGO,
  ALL_AFFILIATES,
} from './affiliates'
import { REDIRECT_EXPERIMENT } from './experimentConfig'

export const EXPERIMENTS_CONFIG = {
  'WEB-5370': {
    active: true,
    affiliates: ALL_AFFILIATES.filter(
      affiliate =>
        affiliate !== AFFILIATE_KAYAK &&
        affiliate !== AFFILIATE_SKYSCANNER &&
        affiliate !== AFFILIATE_TRIVAGO
    ),
    id: 'WEB-5370',
    markets: [],
    devices: [],
    variants: [0, 1],
    variantsProbability: [1, 1],
  },
  [REDIRECT_EXPERIMENT.ID]: {
    active: true,
    affiliates: [AFFILIATE_KAYAK, AFFILIATE_SKYSCANNER],
    id: REDIRECT_EXPERIMENT.ID,
    markets: [],
    devices: [],
    variants: [REDIRECT_EXPERIMENT.REDIRECT_TO_DETAILS, REDIRECT_EXPERIMENT.REDIRECT_TO_SERP],
    variantsProbability: [1, 1],
  },
}
